import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jiantouyou",
  "use": "icon-jiantouyou-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-jiantouyou\"><path fill=\"#8A8A9A\" d=\"M276.22 157.99l354.05 353.39-354.03 353a55.075 55.075 0 0 0-16.19 39c0 49.02 59.24 73.61 93.95 39l386.46-385.33c14.16-9.97 23.42-26.42 23.42-45.06 0-15.23-6.18-29.01-16.17-38.98L354.03 80.04c-34.71-34.64-93.97-10.06-93.97 38.98a55.011 55.011 0 0 0 16.16 38.97z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol